import { ProjectArchiveTrigger } from '@atlassian/jira-project-archive-trigger/src/ui/index.tsx';
import { connect } from '@atlassian/jira-react-redux';
import {
	getProjectTypeSelector,
	getSimplifiedSelector,
	getIsAdmin,
} from '../../../../state/context/selectors';
import type { AppState } from '../../../../state/types';
import { openArchiveProjectModal } from '../../../../state/ui/actions';

const mapStateToProps = (state: AppState) => ({
	projectType: getProjectTypeSelector(state),
	isSimplified: getSimplifiedSelector(state),
	canAdministerProject: true,
	isAdmin: getIsAdmin(state),
});

const mapDispatchToProps = {
	onClick: openArchiveProjectModal,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(ProjectArchiveTrigger);
